export default __webpack_public_path__ + "static/media/pic5.dc51e6b6.jpg";